import { render, staticRenderFns } from "./InventoriesCountingPerformance.vue?vue&type=template&id=4dd3b8b8&scoped=true&"
import script from "./InventoriesCountingPerformance.vue?vue&type=script&lang=ts&"
export * from "./InventoriesCountingPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesCountingPerformance.vue?vue&type=style&index=0&id=4dd3b8b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3b8b8",
  null
  
)

export default component.exports